import styled from 'styled-components';

export const LoginContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;

  @media(max-width: 900px) {
    justify-content: center;
    align-items: center;
  }

  position: relative;
  top: 25%;
  transform: translateY(15%);
  margin: 0 3em;
  margin-top: -8px;
  background: ${({ theme }) => theme.colors.lighterBackground};
  box-shadow: 8px 4px 10px rgba(0, 0, 0, 0.04);
  border-radius: 10px;

  div.asideGif {
    @media(max-width: 900px) {
      display: none;
    }
    width: 40%;
    img {
      width: 100%;
      border-radius: 10px 0px 0px 10px;
    }
  }

  div.asideLogin {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 1.5em 3em;
    width: 60%;
    @media(max-width: 900px) {
      margin: 1.5em;
      width: 90%;
    }

    .loginTitle {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1.5em;
      width: 100%;
      @media(max-width: 900px) {
        flex-direction: column-reverse;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 0em !important;
      }
      img {
        width: 200px;
        @media(max-width: 900px) {
          margin-bottom: 1em !important;
          width: 40%;
        }
      }
      .labelTitle {
        display: flex;
        flex-direction: column;
        div {
          font-size: 24px;
          font-weight: 600;
          @media(max-width: 500px) {
            font-size: 16px;
          }
        }
        .subtitle {
          font-size: 16px;
          font-weight: normal;
          @media(max-width: 500px) {
            font-size: 12px;
          }
        }
      }
    }

    .loginForm {
      width: 100%;
      margin-top: 2em;
      margin-bottom: 0.5em;

      .loginInput {
        margin-bottom: 20px;
      }


    }

    .forgotPassword {
      text-align: center;
      text-decoration: underline;
      margin-top: 16px;

      a {
        &:hover{
        opacity: 0.5;
        transition: ease-in 0.2s;
      }
      &:not(:hover) {
        opacity: 1;
        transition: ease-in 0.2s;
      }
      }
    }

    .signup {
      margin-bottom: 16px;
      font-size: 16px;

      a {
        color: ${({ theme }) => theme.colors.primary.main};
        font-weight: bold;
        /* cursor: not-allowed;
        opacity: 0.4; */
        &:hover{
        opacity: 0.5;
        transition: ease-in 0.2s;
      }
      &:not(:hover) {
        opacity: 1;
        transition: ease-in 0.2s;
      }
      }
    }
  }

`;
